// Auto-generated file, scripts/set-version.js will update this file during build
export const version = '21.0.25';
export const gitHash = 'b918bc3ba';
export const buildTime = '2026-11-04T00:01:19.733Z';
